import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MarkdownIt from "markdown-it";
import markdownItAnchor from "markdown-it-anchor";
import markdownItToc from "markdown-it-toc-done-right";
import hljs from "highlight.js";
import "highlight.js/styles/github.css";
import "highlight.js/styles/github-dark.css";

// 配置MarkdownIt
const md = new MarkdownIt({
   html: true,
   linkify: true,
   typographer: true,
   highlight: function (str, lang) {
      if (lang && hljs.getLanguage(lang)) {
         try {
            return (
               '<pre class="hljs"><code>' +
               hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
               "</code></pre>"
            );
         } catch (__) {}
      }
      return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + "</code></pre>";
   },
});

// 添加插件
md.use(markdownItAnchor, {
   permalink: true,
   permalinkSymbol: "", // 将符号设为空字符串
   permalinkBefore: false, // 将链接放在标题后面而不是前面
   permalinkClass: "header-anchor",
   permalinkSpace: false, // 移除空格
});
md.use(markdownItToc);

function BlogPost() {
   const { slug } = useParams();
   const [content, setContent] = useState("");
   const [metadata, setMetadata] = useState({
      title: "",
      date: "",
   });
   const [isLoading, setIsLoading] = useState(true);

   useEffect(() => {
      const fetchContent = async () => {
         try {
            setIsLoading(true);
            const response = await fetch(`/assets/blog/${slug}.md`);
            const text = await response.text();

            // 提取元数据
            const titleMatch = text.match(/# (.+)\n/);
            const dateMatch = text.match(/发布日期：(.+)\n/);

            if (titleMatch) {
               setMetadata((prev) => ({ ...prev, title: titleMatch[1] }));
            }

            if (dateMatch) {
               setMetadata((prev) => ({ ...prev, date: dateMatch[1] }));
            }

            setContent(md.render(text));
            setIsLoading(false);
         } catch (error) {
            console.error("Error loading blog post:", error);
            setIsLoading(false);
         }
      };

      fetchContent();
   }, [slug]);

   return (
      <main className="container mx-auto max-width pt-10 mb-20 min-h-screen flex flex-col items-center">
         {isLoading ? (
            <div className="w-full max-w-3xl px-4 py-8 flex justify-center">
               <div className="animate-pulse h-4 bg-gray-200 rounded w-1/4"></div>
            </div>
         ) : (
            <article className="prose dark:prose-invert w-full max-w-3xl px-4">
               {/* {metadata.title && metadata.date && (
                  <div className="mb-8 border-b border-gray-200 dark:border-gray-700 pb-4">
                     <h1 className="text-2xl font-bold text-dark-heading dark:text-light-heading mb-2">
                        {metadata.title}
                     </h1>
                     <div className="text-sm text-gray-500 dark:text-gray-400">{metadata.date}</div>
                  </div>
               )} */}
               <div className="markdown-body dark:markdown-body-dark" dangerouslySetInnerHTML={{ __html: content }} />
            </article>
         )}
      </main>
   );
}

export default BlogPost;
